(() => {
  const STORAGE_KEY = 'mareldWishlist';


  /* =========================
     Speicher lesen
     ========================= */

  const readWishlist = () => {
    try {
      const stored = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      console.warn(
        'MARELD Wishlist: Daten konnten nicht gelesen werden.',
        error
      );

      return [];
    }
  };


  /* =========================
     Speicher schreiben
     ========================= */

  const writeWishlist = (items) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(items)
      );
    } catch (error) {
      console.warn(
        'MARELD Wishlist: Daten konnten nicht gespeichert werden.',
        error
      );
    }
  };


  /* =========================
     Hilfsfunktionen
     ========================= */

  const normalizeId = (value) => {
    return String(value || '');
  };


  const isSaved = (
    productId,
    items = readWishlist()
  ) => {
    const id = normalizeId(productId);

    return items.some(
      (item) =>
        normalizeId(item.id) === id
    );
  };


  /* =========================
     Button-Status
     ========================= */

  const setButtonState = (
    button,
    active
  ) => {

    button.setAttribute(
      'aria-pressed',
      active ? 'true' : 'false'
    );


    button.classList.toggle(
      'is-active',
      active
    );


    button.setAttribute(
      'aria-label',
      active
        ? 'Vom Merkzettel entfernen'
        : 'Zum Merkzettel hinzufügen'
    );


    const label =
      button.querySelector(
        '[data-wishlist-label]'
      );


    if (label) {
      label.textContent =
        active
          ? 'Auf dem Merkzettel'
          : 'Zum Merkzettel';
    }

  };


  /* =========================
     Alle Wishlist-Buttons
     synchronisieren
     ========================= */

  const syncButtons = (
    root = document
  ) => {

    const items =
      readWishlist();


    root
      .querySelectorAll(
        '[data-wishlist-button]'
      )
      .forEach(
        (button) => {

          setButtonState(
            button,
            isSaved(
              button.dataset.productId,
              items
            )
          );

        }
      );

  };


  /* =========================
     Header-Zähler
     ========================= */

  const updateWishlistCount = (
    items = readWishlist()
  ) => {

    const count =
      items.length;


    document
      .querySelectorAll(
        '[data-wishlist-count]'
      )
      .forEach(
        (counter) => {

          if (count <= 0) {

            counter.hidden = true;
            counter.textContent = '0';

            return;
          }


          counter.hidden = false;


          counter.textContent =
            count > 99
              ? '99+'
              : String(count);

        }
      );

  };


  /* =========================
     Änderungs-Event
     ========================= */

  const notifyChange = (
    items
  ) => {

    updateWishlistCount(items);


    document.dispatchEvent(
      new CustomEvent(
        'mareld:wishlist:changed',
        {
          detail: {
            count: items.length,
            items
          }
        }
      )
    );

  };


  /* =========================
     Produkt hinzufügen /
     entfernen
     ========================= */

  const toggleProduct = (
    button
  ) => {

    const productId =
      normalizeId(
        button.dataset.productId
      );


    if (!productId) return;


    let items =
      readWishlist();


    const existingIndex =
      items.findIndex(
        (item) =>
          normalizeId(item.id) ===
          productId
      );


    if (existingIndex >= 0) {

      items.splice(
        existingIndex,
        1
      );

    } else {

      items.push({
        id: productId,
        handle:
          button.dataset.productHandle ||
          '',
        url:
          button.dataset.productUrl ||
          ''
      });

    }


    writeWishlist(items);


    const nowActive =
      existingIndex < 0;


    document
      .querySelectorAll(
        '[data-wishlist-button]'
      )
      .forEach(
        (matchingButton) => {

          if (
            normalizeId(
              matchingButton.dataset.productId
            ) === productId
          ) {

            setButtonState(
              matchingButton,
              nowActive
            );

          }

        }
      );


    notifyChange(items);

  };


  /* =========================
     HTML sicher ausgeben
     ========================= */

  const escapeHtml = (
    value = ''
  ) => {

    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  };


  /* =========================
     Geld formatieren
     ========================= */

  const money = (
    cents
  ) => {

    const currency =
      window.Shopify?.currency?.active ||
      window.Shopify?.currency?.shop_currency ||
      'EUR';


    return new Intl.NumberFormat(
      document.documentElement.lang ||
      'de-DE',
      {
        style: 'currency',
        currency
      }
    ).format(
      (Number(cents) || 0) / 100
    );

  };


  /* =========================
     Produkt laden
     ========================= */

  const getProduct = async (
    handle
  ) => {

    const root =
      window.Shopify?.routes?.root ||
      '/';


    const response =
      await fetch(
        `${root}products/${encodeURIComponent(handle)}.js`,
        {
          credentials:
            'same-origin'
        }
      );


    if (!response.ok) {

      throw new Error(
        `Produkt ${handle} konnte nicht geladen werden.`
      );

    }


    return response.json();

  };


  /* =========================
     Warenkorb-Aktion bestimmen
     ========================= */

  const getCartAction = (product) => {
    const availableVariants = (product.variants || []).filter(
      (variant) => variant.available
    );

    if (!availableVariants.length) {
      return { type: 'sold-out', label: 'Ausverkauft' };
    }

    if (availableVariants.length === 1) {
      return {
        type: 'add',
        label: 'In den Warenkorb',
        variantId: availableVariants[0].id
      };
    }

    return { type: 'choose', label: 'Variante wählen' };
  };


  /* =========================
     Produkt in Warenkorb
     ========================= */

  const addVariantToCart = async (button) => {
    const variantId = normalizeId(button.dataset.variantId);

    if (!variantId || button.disabled) return;

    const originalHtml = button.innerHTML;

    button.disabled = true;
    button.classList.add('is-loading');
    button.innerHTML = '<span class="btn__text">Wird hinzugefügt …</span>';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));

        throw new Error(
          errorData.description ||
          errorData.message ||
          'Produkt konnte nicht in den Warenkorb gelegt werden.'
        );
      }

      await response.json();

      button.innerHTML = '<span class="btn__text">Im Warenkorb</span>';

      /*
       * Der Merkzettel bleibt unverändert.
       * Vor dem Reload merken wir uns, dass Pillars Cart Drawer
       * nach dem vollständigen Warenkorb-Refresh automatisch öffnen soll.
       */
      try {
        sessionStorage.setItem(
          'mareldOpenCartDrawerAfterReload',
          '1'
        );
      } catch (error) {
        console.warn(
          'MARELD Wishlist: Cart-Drawer-Merker konnte nicht gespeichert werden.',
          error
        );
      }

      window.setTimeout(() => {
        window.location.reload();
      }, 500);

    } catch (error) {
      console.warn(
        'MARELD Wishlist: Warenkorb konnte nicht aktualisiert werden.',
        error
      );

      button.disabled = false;
      button.classList.remove('is-loading');
      button.innerHTML = originalHtml;
    }
  };


  /* =========================
     Pillar-Farbfelder
     Merkzettelseite
     ========================= */

  const swatchCache = new Map();

  const getColorOptionIndex = (product) => {
    const options = product.options || [];

    return options.findIndex((option) => {
      const name =
        typeof option === 'string'
          ? option
          : option?.name || '';

      return ['farbe', 'color', 'colour'].includes(
        String(name).trim().toLowerCase()
      );
    });
  };

  const getColorVariants = (product) => {
    const colorIndex = getColorOptionIndex(product);

    if (colorIndex < 0) return [];

    const colors = [];
    const seen = new Set();

    (product.variants || []).forEach((variant) => {
      const value = variant.options?.[colorIndex];

      if (!value) return;

      const key = String(value).trim().toLowerCase();

      if (seen.has(key)) return;

      seen.add(key);

      const variantImage =
        variant.featured_image ||
        variant.featured_media?.preview_image ||
        null;

      colors.push({
        name: String(value),
        variantId: variant.id,
        available: Boolean(variant.available),
        imageUrl:
          variantImage?.src ||
          variantImage?.url ||
          ''
      });
    });

    return colors;
  };

  const getProductPageHtml = async (productUrl) => {
    const cleanUrl = String(productUrl || '').split('?')[0];

    if (!cleanUrl) return '';

    if (swatchCache.has(cleanUrl)) {
      return swatchCache.get(cleanUrl);
    }

    const request = fetch(cleanUrl, {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html'
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Produktseite konnte nicht geladen werden: ${response.status}`
          );
        }

        return response.text();
      })
      .catch((error) => {
        console.warn(
          'MARELD Wishlist: Pillar-Farbfelder konnten nicht geladen werden.',
          error
        );

        return '';
      });

    swatchCache.set(cleanUrl, request);

    return request;
  };

  const getSwatchValue = (swatch, doc) => {
    const direct =
      swatch.getAttribute('aria-label') ||
      swatch.getAttribute('title');

    if (direct) {
      return direct.split(' - ').pop().trim();
    }

    const label = swatch.closest('label');

    if (label) {
      const forId = label.getAttribute('for');

      if (forId) {
        const input = doc.getElementById(forId);

        if (input?.value) {
          return String(input.value).trim();
        }
      }

      const labelText =
        label.querySelector('.reversed-link__text')?.textContent;

      if (labelText) {
        return labelText.trim();
      }
    }

    const tooltip =
      swatch.querySelector('.tooltip')?.textContent;

    return tooltip ? tooltip.trim() : '';
  };

  const extractPillarSwatches = (html, product) => {
    if (!html) return new Map();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const expectedColors = getColorVariants(product);

    const expectedKeys = new Set(
      expectedColors.map((color) =>
        color.name.trim().toLowerCase()
      )
    );

    const selectors = [
      'main .product-form__input--swatch .swatch-color',
      'main .product-form__input--color .swatch-color',
      'main [data-swatch-type] .swatch-color',
      'main variant-selects .swatch-color',
      'main variant-radios .swatch-color',
      'main .swatches .swatch-color'
    ];

    const candidates = Array.from(
      doc.querySelectorAll(selectors.join(','))
    );

    const result = new Map();

    candidates.forEach((swatch) => {
      const value = getSwatchValue(swatch, doc);

      if (!value) return;

      const key = value.trim().toLowerCase();

      if (!expectedKeys.has(key) || result.has(key)) {
        return;
      }

      result.set(key, {
        style: swatch.getAttribute('style') || '',
        className:
          swatch.getAttribute('class') ||
          'swatch-color block relative'
      });
    });

    return result;
  };

  const buildPillarSwatches = async (product, card) => {
    const container =
      card?.querySelector('[data-wishlist-swatches]');

    if (!container) return;

    const colors = getColorVariants(product);

    if (!colors.length) {
      container.remove();
      return;
    }

    const productUrl =
      product.url ||
      `/products/${product.handle}`;

    const html =
      await getProductPageHtml(productUrl);

    const pillarSwatches =
      extractPillarSwatches(html, product);

    const maxSwatches = 4;

    const availableSwatches = colors
      .map((color) => {
        const key =
          color.name.trim().toLowerCase();

        const pillar =
          pillarSwatches.get(key);

        if (!pillar) return null;

        return {
          color,
          pillar
        };
      })
      .filter(Boolean);

    if (!availableSwatches.length) {
      container.remove();
      return;
    }

    const visibleSwatches =
      availableSwatches.slice(
        0,
        maxSwatches
      );

    const hiddenSwatchCount =
      Math.max(
        availableSwatches.length -
          visibleSwatches.length,
        0
      );

    const swatches = visibleSwatches
      .map(({ color, pillar }) => {
        const url =
          `${String(productUrl).split('?')[0]}?variant=${encodeURIComponent(color.variantId)}`;

        return `
          <li
            class="swatch-item${color.available ? '' : ' mareld-wishlist-swatch--unavailable'}"
            data-tooltip
          >
            <a
              href="${escapeHtml(url)}"
              class="${escapeHtml(pillar.className)}"
              style="${escapeHtml(pillar.style)}"
              data-wishlist-color
              data-image-url="${escapeHtml(color.imageUrl)}"
              aria-label="${escapeHtml(product.title)} - ${escapeHtml(color.name)}"
              title="${escapeHtml(product.title)} - ${escapeHtml(color.name)}"
            >
              <span class="tooltip pointer-events-none">${escapeHtml(color.name)}</span>
            </a>
          </li>
        `;
      });

    if (hiddenSwatchCount > 0) {
      swatches.push(`
        <li class="swatch-more mareld-wishlist-card__swatch-more">
          <a
            href="${escapeHtml(String(productUrl).split('?')[0])}"
            class="block reversed-link text-sm-extra"
            aria-label="${escapeHtml(hiddenSwatchCount)} weitere Farben anzeigen"
          >
            <span class="reversed-link__text">+${hiddenSwatchCount}</span>
          </a>
        </li>
      `);
    }

    container.innerHTML = swatches.join('');
    container.hidden = false;
  };

  const hydrateWishlistSwatches = async (products, grid) => {
    await Promise.allSettled(
      products.map((product) => {
        const card =
          grid.querySelector(
            `[data-wishlist-card="${CSS.escape(String(product.id))}"]`
          );

        return buildPillarSwatches(
          product,
          card
        );
      })
    );
  };


  /* =========================
     Produktkarte
     Merkzettelseite
     ========================= */

  const productCardHtml = (
    product
  ) => {

    const productUrl =
      product.url ||
      `/products/${product.handle}`;


    const image =
      product.featured_image ||
      (
        product.images &&
        product.images[0]
      ) ||
      '';


    const imageUrl =
      typeof image === 'string'
        ? image
        : image?.src || '';


    const prices =
      (product.variants || [])
        .map(
          (variant) =>
            Number(
              variant.price || 0
            )
        );


    const hasDifferentPrices =
      prices.length > 1 &&
      Math.min(...prices) !==
      Math.max(...prices);


    const pricePrefix =
      hasDifferentPrices
        ? 'Ab '
        : '';


    const cartAction =
      getCartAction(product);


    return `
      <article
        class="mareld-wishlist-card"
        data-wishlist-card="${escapeHtml(product.id)}"
      >

        <div class="mareld-wishlist-card__media">

          <a
            class="mareld-wishlist-card__image-link"
            href="${escapeHtml(productUrl)}"
            aria-label="${escapeHtml(product.title)}"
          >

            ${
              imageUrl
                ? `
                  <img
                    class="mareld-wishlist-card__image"
                    src="${escapeHtml(imageUrl)}"
                    alt="${escapeHtml(product.title)}"
                    loading="lazy"
                  >
                `
                : ''
            }

          </a>


          <button
            type="button"
            class="mareld-wishlist-button"
            data-wishlist-button
            data-product-id="${escapeHtml(product.id)}"
            data-product-handle="${escapeHtml(product.handle)}"
            data-product-url="${escapeHtml(productUrl)}"
            aria-label="Vom Merkzettel entfernen"
            aria-pressed="true"
          >

            <span
              class="mareld-wishlist-button__icon"
              aria-hidden="true"
            >

              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
              >

                <path
                  d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />

              </svg>

            </span>

          </button>

        </div>


        <div class="mareld-wishlist-card__info">

          ${
            product.vendor
              ? `
                <p class="mareld-wishlist-card__vendor">
                  ${escapeHtml(product.vendor)}
                </p>
              `
              : ''
          }


          <h2
            class="mareld-wishlist-card__title"
          >

            <a
              href="${escapeHtml(productUrl)}"
            >
              ${escapeHtml(product.title)}
            </a>

          </h2>


          <p
            class="mareld-wishlist-card__price"
          >
            ${pricePrefix}${money(product.price)}
          </p>


          <ul
            class="mareld-wishlist-card__swatches product-card__swatches swatches swatches--product-card flex flex-wrap gap-2 items-center justify-start"
            data-wishlist-swatches
            hidden
          ></ul>


          <div class="mareld-wishlist-card__actions">
            ${
              cartAction.type === 'add'
                ? `
                  <button
                    type="button"
                    class="btn btn--primary mareld-wishlist-card__cart-button"
                    data-wishlist-add-to-cart
                    data-variant-id="${escapeHtml(cartAction.variantId)}"
                  >
                    <span class="btn__text">${escapeHtml(cartAction.label)}</span>
                  </button>
                `
                : ''
            }

            ${
              cartAction.type === 'choose'
                ? `
                  <a
                    class="btn btn--secondary mareld-wishlist-card__cart-button"
                    href="${escapeHtml(productUrl)}"
                  >
                    <span class="btn__text">${escapeHtml(cartAction.label)}</span>
                  </a>
                `
                : ''
            }

            ${
              cartAction.type === 'sold-out'
                ? `
                  <button
                    type="button"
                    class="btn btn--secondary mareld-wishlist-card__cart-button"
                    disabled
                    aria-disabled="true"
                  >
                    <span class="btn__text">${escapeHtml(cartAction.label)}</span>
                  </button>
                `
                : ''
            }
          </div>

        </div>

      </article>
    `;

  };


  /* =========================
     Merkzettelseite rendern
     ========================= */

  const renderWishlistPage =
    async (
      section
    ) => {

      const grid =
        section.querySelector(
          '[data-wishlist-grid]'
        );


      const empty =
        section.querySelector(
          '[data-wishlist-empty]'
        );


      const loading =
        section.querySelector(
          '[data-wishlist-loading]'
        );


      const items =
        readWishlist();


      if (
        !grid ||
        !empty ||
        !loading
      ) {

        return;

      }


      if (!items.length) {

        loading.hidden = true;

        grid.hidden = true;
        grid.innerHTML = '';

        empty.hidden = false;

        return;

      }


      loading.hidden = false;

      grid.hidden = true;

      empty.hidden = true;


      const results =
        await Promise.allSettled(

          items
            .filter(
              (item) =>
                item.handle
            )
            .map(
              (item) =>
                getProduct(
                  item.handle
                )
            )

        );


      const products =
        results
          .filter(
            (result) =>
              result.status ===
              'fulfilled'
          )
          .map(
            (result) =>
              result.value
          );


      loading.hidden = true;


      if (!products.length) {

        grid.hidden = true;
        grid.innerHTML = '';

        empty.hidden = false;

        return;

      }


      grid.innerHTML =
        products
          .map(
            productCardHtml
          )
          .join('');


      grid.hidden = false;

      empty.hidden = true;


      syncButtons(
        grid
      );


      hydrateWishlistSwatches(
        products,
        grid
      );

  };


  /* =========================
     Alle Merkzettelseiten
     ========================= */

  const renderAllWishlistPages =
    () => {

      document
        .querySelectorAll(
          '[data-mareld-wishlist-page]'
        )
        .forEach(
          (section) =>
            renderWishlistPage(
              section
            )
        );

    };


  /* =========================
     Farbfelder: Bildvorschau Desktop
     ========================= */

  document.addEventListener(
    'mouseover',
    (event) => {

      const swatch =
        event.target.closest(
          '[data-wishlist-color]'
        );


      if (
        !swatch ||
        window.matchMedia?.(
          '(hover: none), (pointer: coarse)'
        ).matches
      ) {

        return;

      }


      const card =
        swatch.closest(
          '.mareld-wishlist-card'
        );


      const image =
        card?.querySelector(
          '.mareld-wishlist-card__image'
        );


      const imageUrl =
        swatch.dataset.imageUrl;


      if (
        image &&
        imageUrl
      ) {

        image.src =
          imageUrl;

      }


      card
        ?.querySelectorAll(
          '.swatch-item'
        )
        .forEach(
          (item) => {

            item.removeAttribute(
              'aria-selected'
            );

          }
        );


      swatch
        .closest(
          '.swatch-item'
        )
        ?.setAttribute(
          'aria-selected',
          'true'
        );

    }
  );


  /* =========================
     Touch-Animation Aktionsbuttons
     ========================= */

  const isTouchDevice = () => {
    return window.matchMedia?.(
      '(hover: none), (pointer: coarse)'
    ).matches;
  };


  const runTouchButtonAnimation = (
    button,
    callback
  ) => {

    if (!button || !isTouchDevice()) {
      callback?.();
      return;
    }


    button.classList.add(
      'is-touch-active'
    );


    window.setTimeout(
      () => {

        callback?.();

      },
      260
    );


    window.setTimeout(
      () => {

        button.classList.remove(
          'is-touch-active'
        );

      },
      520
    );

  };


  /* =========================
     Klick auf Wishlist
     ========================= */

  document.addEventListener(
    'click',
    (event) => {

      const actionButton =
        event.target.closest(
          '.mareld-wishlist-card__cart-button'
        );


      if (
        actionButton &&
        actionButton.matches('a') &&
        isTouchDevice()
      ) {

        event.preventDefault();
        event.stopPropagation();

        const targetUrl =
          actionButton.href;


        runTouchButtonAnimation(
          actionButton,
          () => {

            window.location.href =
              targetUrl;

          }
        );

        return;
      }


      const cartButton =
        event.target.closest(
          '[data-wishlist-add-to-cart]'
        );


      if (cartButton) {

        event.preventDefault();
        event.stopPropagation();


        runTouchButtonAnimation(
          cartButton,
          () => {

            addVariantToCart(
              cartButton
            );

          }
        );

        return;
      }


      const button =
        event.target.closest(
          '[data-wishlist-button]'
        );


      if (!button) return;


      event.preventDefault();

      event.stopPropagation();


      toggleProduct(
        button
      );

    }
  );


  /* =========================
     Wishlist geändert
     ========================= */

  document.addEventListener(
    'mareld:wishlist:changed',
    () => {

      renderAllWishlistPages();


      openCartDrawerAfterReload();

    }
  );


  /* =========================
     Cart Drawer nach Reload öffnen
     ========================= */

  const openCartDrawerAfterReload = () => {
    let shouldOpen = false;

    try {
      shouldOpen =
        sessionStorage.getItem(
          'mareldOpenCartDrawerAfterReload'
        ) === '1';

      if (shouldOpen) {
        sessionStorage.removeItem(
          'mareldOpenCartDrawerAfterReload'
        );
      }
    } catch (error) {
      console.warn(
        'MARELD Wishlist: Cart-Drawer-Merker konnte nicht gelesen werden.',
        error
      );
    }

    if (!shouldOpen) return;

    window.setTimeout(() => {
      const cartButton =
        document.querySelector(
          '[aria-controls="CartDrawer"], .cart-drawer-button'
        );

      if (cartButton) {
        cartButton.click();
        return;
      }

      const cartDrawer =
        document.querySelector(
          '#CartDrawer, cart-drawer, [data-cart-drawer]'
        );

      if (!cartDrawer) return;

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }

      cartDrawer.setAttribute(
        'open',
        ''
      );
    }, 250);
  };


  /* =========================
     Seitenstart
     ========================= */

  document.addEventListener(
    'DOMContentLoaded',
    () => {

      const items =
        readWishlist();


      syncButtons();


      updateWishlistCount(
        items
      );


      renderAllWishlistPages();

    }
  );


  /* =========================
     Browser Zurück / Vor
     ========================= */

  window.addEventListener(
    'pageshow',
    () => {

      const items =
        readWishlist();


      syncButtons();


      updateWishlistCount(
        items
      );


      renderAllWishlistPages();

    }
  );


  /* =========================
     Shopify Theme Editor
     ========================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      syncButtons(
        event.target
      );


      updateWishlistCount(
        readWishlist()
      );


      if (
        event.target.matches?.(
          '[data-mareld-wishlist-page]'
        ) ||
        event.target.querySelector?.(
          '[data-mareld-wishlist-page]'
        )
      ) {

        renderAllWishlistPages();

      }

    }
  );


  /* =========================
     Öffentliche API
     ========================= */

  window.MareldWishlist = {

    getItems:
      readWishlist,

    count:
      () =>
        readWishlist().length,

    contains:
      (productId) =>
        isSaved(productId),

    sync:
      syncButtons,

    render:
      renderAllWishlistPages,

    updateCount:
      updateWishlistCount

  };

})();